var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopyFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 5.66671C17.1939 5.66671 16 6.86062 16 8.33337V35C16 36.4728 17.1939 37.6667 18.6667 37.6667H40C41.4728 37.6667 42.6667 36.4728 42.6667 35V17.4379L30.8954 5.66671H18.6667ZM10.6667 8.33337C10.6667 3.9151 14.2484 0.333374 18.6667 0.333374H30.8954C32.3099 0.333374 33.6665 0.895279 34.6667 1.89547L46.4379 13.6667C47.4381 14.6669 48 16.0235 48 17.4379V35C48 39.4183 44.4183 43 40 43H37.3333V45.6667C37.3333 50.085 33.7516 53.6667 29.3333 53.6667H8C3.58172 53.6667 0 50.085 0 45.6667V19C0 14.5818 3.58172 11 8 11H10.6667V8.33337ZM10.6667 16.3334H8C6.52724 16.3334 5.33333 17.5273 5.33333 19V45.6667C5.33333 47.1395 6.52724 48.3334 8 48.3334H29.3333C30.8061 48.3334 32 47.1395 32 45.6667V43H18.6667C14.2484 43 10.6667 39.4183 10.6667 35V16.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyFile);
export default __webpack_public_path__ + "static/media/icon-copy-file.3b29a02c6ad000c2c0a3d0cbf0b7cde4.svg";
export { ForwardRef as ReactComponent };